// extracted by mini-css-extract-plugin
module.exports = {"ReferenceDisplay":"ReferenceDisplay_ReferenceDisplay__1z_Y4"};